import * as api from '@owl-nest/api-client/latest'
import * as models from '@owl-nest/models'

import type { ApiResponse } from '@owl-nest/api-client'

export async function add(
  project: models.project.ProjectForOwner | models.project.ProjectForStaff,
  payload: { username: string; role: 'moderator' | 'editor' | 'coordinator' },
): Promise<ApiResponse<any>> {
  const response = await api.api.post.projectMember({
    urlParams: { projectId: String(project.id) },
    body: payload,
  })

  return response.next((success) => success.body)
}

export async function remove(memberId: number): Promise<ApiResponse<any>> {
  const response = await api.api.delete.member({
    urlParams: { memberId: String(memberId) },
  })

  return response.next((success) => success.body)
}

export async function update(memberId: number, payload: { role: 'moderator' | 'editor' | 'coordinator' }) {
  const response = await api.api.patch.member({
    urlParams: { memberId: String(memberId) },
    body: payload,
  })

  return response.next((success) => success.body)
}
